import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import PalworldView from '../views/PalworldView.vue'
import CraftopiaView from '../views/CraftopiaView.vue'
import AiArtImpostorView from '../views/AiArtImpostorView.vue'
import SubmittedView from '../views/SubmittedView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/palworld',
    name: 'palworld',
    component: PalworldView
  },
  {
    path: '/craftopia',
    name: 'craftopia',
    component: CraftopiaView
  },
  {
    path: '/aiartimpostor',
    name: 'aiartimpostor',
    component: AiArtImpostorView
  },
  {
    path: '/submitted',
    name: 'submitted',
    component: SubmittedView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
